import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useOptionPmsColorListQuery } from "./_repository/query/use-case";
import { OptionPmsPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const OptionPmsContainer = ({ hotelID }: Props) => {
	/**
	 * カラーリストの取得
	 */
	const { optionPmsColorListQueryData } = useOptionPmsColorListQuery({ hotelID });

	if (!optionPmsColorListQueryData) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <OptionPmsPresenter hotelID={hotelID} optionPmsColorListQueryData={optionPmsColorListQueryData} />;
};
